import React from 'react';
import styles from "./Video.css";
import Header from "../../components/features/login/Header";
import TitleModule from '../../components/features/register/TitleModule';
import RegisterProgress from '../../components/features/register/RegisterProgress';
import TextFile from "../../components/Intro-Leitura/TextFile"

const TextIntro = () => {
    return (
      <div className="video-Page"> 
        <Header/>
        <div className={styles.container}>
            <TitleModule/>
            <RegisterProgress step={2} title="Conheça a tecnologia" icon="Dvr"/>
            <TextFile/>
        </div>
      </div>
    );
  };
  
  export default TextIntro;
  